'use client';

import { Auth } from '@aws-amplify/auth';
import { configAws } from 'constants/aws';
import { ENV_IS_LOCAL_AUTH } from 'constants/env';
import { LocalAuth } from 'lib/auth/LocalAuth';
import { notifyException } from 'services/appsignal';

export const getToken = async () => {
  try {
    if (ENV_IS_LOCAL_AUTH) {
      const session = new LocalAuth();

      return session.currentSession().getAccessToken().getJwtToken();
    }

    Auth.configure(configAws.Auth);

    const token = (await Auth.currentSession()).getAccessToken().getJwtToken();
    return token;
  } catch (error) {
    notifyException(error);

    return '';
  }
};
